/**
 * AVA-792: what the tag screens offer for the current facility's group, defined once.
 * The scope comes from GET api/Facilities/{id}/group-scope (getter FACILITY/GET_GROUP_SCOPE). The server
 * checks every write again, so these rules only decide what the UI shows.
 */

/** Create screens that may offer a group owner: their writers accept one. T11 adds the rest. */
export const GROUP_OWNER_CREATE_TYPES = Object.freeze([
  'Anomaly', 'Scaffold', 'Permit', 'Container', 'Equipment', 'Pipeline', 'Structural',
  'Inspection', 'General', 'AVA Inspect',
]);

export function isInGroup(scope) {
  return Boolean(scope && scope.groupId);
}

export function facilityCountLabel(scope) {
  const count = (scope && scope.facilityCount) || 0;
  return `${count} ${count === 1 ? 'facility' : 'facilities'}`;
}

export function canOfferGroupOwner(scope, tagType) {
  return isInGroup(scope) && GROUP_OWNER_CREATE_TYPES.includes(tagType);
}

/** Why this user can't create a group-owned tag, or null when they can. */
export function groupCreateBlockReason(scope) {
  if (!isInGroup(scope) || scope.canWrite) return null;
  return `You need access to all ${facilityCountLabel(scope)} in ${scope.groupName} to create a shared tag.`;
}

/** Why this user can't change a group-owned tag, or null when they can (or the tag is not the group's). */
export function groupWriteBlockReason(tag, scope) {
  const groupId = tag && tag.facilityGroupId;
  if (!groupId || !isInGroup(scope) || scope.groupId !== groupId || scope.canWrite) return null;
  return `Shared by ${scope.groupName}. Changing it needs access to all ${facilityCountLabel(scope)}.`;
}

/** The first group-write block among the selected tags, or null when the user can change them all. */
export function selectionWriteBlockReason(tags, scope) {
  for (const tag of tags || []) {
    const reason = groupWriteBlockReason(tag, scope);
    if (reason) return reason;
  }
  return null;
}
